import $ from "jquery";

const Accordion = (el) => {
    const $el = $(el);

    $el.on("click", function (e) {
        if ($el.hasClass("js-state-accordion-open")) {
            $el.removeClass("js-state-accordion-open");
            $el.next().slideUp();
            $el.attr("aria-expanded", "false");
        } else {
            $el.addClass("js-state-accordion-open");
            $el.next().slideDown();
            $el.attr("aria-expanded", "true");
        }
    });
};

export default Accordion;
